import { render, staticRenderFns } from "./LinkedDocuments.vue?vue&type=template&id=4c31d8e1&"
import script from "./LinkedDocuments.vue?vue&type=script&lang=js&"
export * from "./LinkedDocuments.vue?vue&type=script&lang=js&"
import style0 from "./LinkedDocuments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports